import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function FaqSection() {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  const faqs = [{
    q: '¿Necesito saber de tecnología o programación?',
    a: 'No. Todo el sistema usa herramientas gratuitas con interfaces simples. Si sabes escribir un mensaje de WhatsApp, sabes usar este sistema. El ebook te guía paso a paso desde cero.'
  }, {
    q: 'Ya usé ChatGPT y no me funcionó. ¿Por qué esto sería diferente?',
    a: 'Exactamente por eso existe este sistema. El problema no fue la herramienta — fue que nadie te enseñó cómo instruirla correctamente. El Método R.I.C.E. cambia completamente los resultados que obtienes de la IA.'
  }, {
    q: '¿Cuánto tiempo necesito para implementarlo?',
    a: 'El setup inicial toma 30 minutos. El Workflow de 4 Horas lo ejecutas una vez por semana — idealmente un sábado — y tienes todo el contenido de la semana siguiente listo y programado.'
  }, {
    q: '¿Funciona para mi nicho específico?',
    a: 'Sí. Los 50 prompts incluidos son completamente adaptables a cualquier nicho: servicios profesionales, coaching, e-commerce, restaurantes, salud, bienes raíces, tecnología y más. Solo cambias los campos entre corchetes.'
  }, {
    q: '¿El contenido va a sonar genérico o de IA?',
    a: 'No. El Capítulo 4 incluye la técnica de Muestreo de Estilo que "educa" a tu IA sobre tu tono, tus muletillas y tu forma de comunicarte. El resultado es contenido que suena exactamente como tú — pero producido 10 veces más rápido.'
  }, {
    q: '¿Qué pasa si la IA cambia o se actualiza?',
    a: 'El Capítulo 7 está dedicado exactamente a esto. El Método R.I.C.E. es agnóstico a la plataforma — funciona en ChatGPT, Claude, Gemini o cualquier IA que salga mañana. El método importa más que la herramienta.'
  }, {
    q: '¿Cómo recibo el ebook después de comprar?',
    a: 'Inmediatamente después del pago recibes un correo con el enlace de descarga directa en PDF. Sin esperas. Puedes leerlo en tu celular, tablet o computadora.'
  }];
  const toggleFaq = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  return <section className="py-28 px-6 bg-darker" data-id="element-78">
      <div className="max-w-[700px] mx-auto" data-id="element-79">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-[60px]" data-id="element-80">
          <span className="inline-block text-orange text-xs font-bold tracking-[2px] uppercase mb-4" data-id="element-81">
            Preguntas Frecuentes
          </span>
          <h2 className="text-[clamp(28px,4vw,48px)] font-black text-white" data-id="element-82">
            Resolvemos tus dudas
          </h2>
        </motion.div>

        <div className="flex flex-col gap-4" data-id="element-83">
          {faqs.map((faq, i) => {
          const isActive = activeIndex === i;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.05
          }} className={`bg-cardBg border rounded-2xl overflow-hidden transition-colors duration-300 ${isActive ? 'border-[rgba(255,107,0,0.3)]' : 'border-border'}`} data-id="element-84">
                <div className="p-6 sm:px-7 flex justify-between items-center cursor-pointer font-bold text-[16px] text-white hover:text-orange transition-colors" onClick={() => toggleFaq(i)} data-id="element-85">
                  {faq.q}
                  <span className={`text-orange text-[24px] font-light shrink-0 transition-transform duration-300 ${isActive ? 'rotate-45' : ''}`} data-id="element-86">
                    +
                  </span>
                </div>
                <AnimatePresence data-id="element-87">
                  {isActive && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-88">
                      <div className="px-6 sm:px-7 pb-6 text-[15px] text-[#AAAAAA] leading-[1.8]" data-id="element-89">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}